import React, { ChangeEvent, useState } from 'react';
import { matchesBankSearchKeyword } from '@/common/models/banks/bankSearch';
import type { Bank } from '@/common/models/banks/bank';
import { POPULAR_BANKS_VIEW } from './bankModalSteps';

interface Props {
  banks: Bank[];
  onTransition: (view: number) => void;
  onChangeBank: (bank: Bank) => void;
  onCancel: () => void;
}

export default function SelectBankView({
  banks,
  onTransition,
  onChangeBank,
  onCancel,
}: Props) {
  const [filteredBanks, setFilteredBanks] = useState<Bank[]>([]);
  const [keyword, setKeyword] = useState<string>('');

  const onChangeKeyword = (event: ChangeEvent<HTMLInputElement>) => {
    const keyword = event.target.value;

    if (keyword !== '') {
      setFilteredBanks(banks.filter(b => matchesBankSearchKeyword(b, keyword)));
    } else {
      setFilteredBanks([]);
    }

    setKeyword(keyword);
  };

  return (
    <div className="modal-dialog modal-lg">
      <div className="modal-content">
        <div className="modal-header text-center">
          <h5 className="modal-title w-100">金融機関を選択</h5>
          <button type="button" className="close" onClick={onCancel}>
            <span>&times;</span>
          </button>
        </div>
        <div className="modal-body p-40">
          <form>
            <div className="form-group">
              <label>金融機関を検索</label>
              <input
                type="text"
                className="form-control"
                placeholder="金融機関名を入力"
                value={keyword}
                onChange={onChangeKeyword}
                onKeyDown={event => {
                  if (event.key === 'Enter') {
                    event.preventDefault();
                  }
                }}
              />
            </div>
          </form>
          <div className="row mb-30 bank-select">
            {filteredBanks.map(b => (
              <div className="col-md-4 mb-20" key={b.id}>
                <button
                  type="button"
                  className="btn btn-lg btn-block btn-flat btn-outline-primary"
                  onClick={() => onChangeBank(b)}
                >
                  {b.name}
                </button>
              </div>
            ))}
          </div>
          <button
            type="button"
            className="btn btn-lg back-btn btn-outline-primary"
            onClick={() => onTransition(POPULAR_BANKS_VIEW)}
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
}
